import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  textField: {
    fontFamily: 'Overused Grotesk !important',
    width: '100%'
  }
});

export default useStyles;
